import { render, staticRenderFns } from "./AddFromGalleryTemplateModal.vue?vue&type=template&id=1951f63d&scoped=true"
import script from "./AddFromGalleryTemplateModal.vue?vue&type=script&lang=js"
export * from "./AddFromGalleryTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./AddFromGalleryTemplateModal.vue?vue&type=style&index=0&id=1951f63d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1951f63d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1951f63d')) {
      api.createRecord('1951f63d', component.options)
    } else {
      api.reload('1951f63d', component.options)
    }
    module.hot.accept("./AddFromGalleryTemplateModal.vue?vue&type=template&id=1951f63d&scoped=true", function () {
      api.rerender('1951f63d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/AddFromGalleryTemplateModal.vue"
export default component.exports